import './map.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { Logger } from '../utils/logger';

const COMPONENT_NAME = 'map';
const BEM = {
  BLOCK: COMPONENT_NAME,
  MAP_LIST: 'map__list',
  MAP_POINT: 'map__point',
};

/**
 * version    1.0
 * class      <type> (Map component)
 * classdesc   Map
 */
export class Map {
  constructor($container = $('body')) {
    const self = this;

    this._els = {};
    this._els.container = $container;
    this._els.mapSection = this._els.container.find(`.${BEM.BLOCK}`);

    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.mapSection.each(function () {
        self._initSingleInstance($(this));
      });
    });
  }

  // private methods
  _initSingleInstance($instanceEl) {
    const self = this;
    self._mapLocation($instanceEl);
  }

  _mapLocation($instanceEl) {
    const mapListId = $instanceEl.find(`.${BEM.MAP_LIST}`);

    // Helper methods to handle point activation/deactivation
    const activatePoint = ($element) => {
      Logger.log('map - activatePoint');
      const pointId = $element.data('point-id');
      const point = $instanceEl.find(`.${BEM.MAP_POINT}[data-point-name="${pointId}"]`);
      if (point && point.length > 0) {
        const pointImage = point.find('.tcl-picture__image');
        if (pointImage.length > 0) {
          pointImage.attr('src', pointImage.attr('data-point-src'));
        }
        point.addClass('map__point--active');
      }
    };

    const deactivatePoint = ($element) => {
      Logger.log('map - deactivatePoint');
      const pointId = $element.data('point-id');
      const point = $instanceEl.find(`.${BEM.MAP_POINT}[data-point-name="${pointId}"]`);
      if (point && point.length > 0) {
        point.removeClass('map__point--active');
      }
    };

    // Deactivate all points
    const deactivateAllPoints = () => {
      Logger.log('map - deactivateAllPoints');
      $instanceEl.find(`.${BEM.MAP_POINT}`).removeClass('map__point--active');
    };

    function handleInteraction($element, state) {
      // state = "enter" | "leave" | "tap"
      if (state === 'enter') {
        activatePoint($element);
      } else if (state === 'leave') {
        deactivatePoint($element);
      } else if (state === 'tap') {
        deactivateAllPoints();
        activatePoint($element);
      }
    }

    // Handle both hover and touch events
    const $items = mapListId.find('li');

    // Desktop (hover)
    $items.on('mouseenter', function () {
      Logger.log('map - mouseenter');
      handleInteraction($(this), 'enter');
    });
    $items.on('mouseleave', function () {
      Logger.log('map - mouseleave');
      handleInteraction($(this), 'leave');
    });

    // Mobile (fallback click)
    $items.on('click', function () {
      if ('ontouchstart' in window) return; // evita conflitti
      Logger.log('map - click');
      handleInteraction($(this), 'tap');
    });
  }
}
